export var GroupItem;
(function (GroupItem) {
    GroupItem["MEDICINE"] = "MEDICINE";
    GroupItem["EXAM"] = "EXAM";
    GroupItem["BLOOD"] = "BLOOD";
    GroupItem["NUTRITION"] = "NUTRITION";
    GroupItem["GASTHERAPY"] = "GASTHERAPY";
    GroupItem["DIALYSI"] = "DIALYSI";
    GroupItem["RECOMMENDATION"] = "RECOMMENDATION";
    GroupItem["INTERVENTATATION"] = "INTERVENTATATION";
})(GroupItem || (GroupItem = {}));
export var NutritionType;
(function (NutritionType) {
    NutritionType["ORAL"] = "O";
    NutritionType["ENTERAL"] = "E";
    NutritionType["SUPPLEMENT"] = "S";
    NutritionType["FASTING"] = "J";
    NutritionType["MILK"] = "L";
    NutritionType["WATER_CONTROL"] = "HI";
})(NutritionType || (NutritionType = {}));
export var CpoeConstants;
(function (CpoeConstants) {
    CpoeConstants["YES"] = "S";
    CpoeConstants["NO"] = "N";
})(CpoeConstants || (CpoeConstants = {}));
//# sourceMappingURL=infusions-medicines-cpoe-card-types.js.map